module.exports = __webpack_public_path__ + "static/media/about-img1.3cc2fdf0.png";